import { getRrwebIframe } from '@carboncopyco/mimesis-shared';
import type { RefObject } from 'react';

export default function expandBody(rootElement: RefObject<HTMLElement>) {
  const iframe = getRrwebIframe(rootElement?.current);
  if (!iframe) {
    return;
  }

  const body = iframe.contentDocument.body;
  if (!body) {
    return;
  }

  function handleMutations(_, observer: MutationObserver) {
    const iframeHeight = iframe.contentWindow.innerHeight;

    if (iframeHeight > 0) {
      observer.disconnect();

      if (body.clientHeight < iframeHeight) {
        const children = Array.from(body.children);
        const highestElement = children.sort(
          (a, b) => b.clientHeight - a.clientHeight
        )?.[0];

        if (!highestElement || highestElement.clientHeight === 0) {
          body.setAttribute('style', `height: ${iframeHeight}px !important;`);
          body.setAttribute('data-ds-window-height', '');
          return;
        }

        body.setAttribute(
          'style',
          `height: ${highestElement.clientHeight}px !important;`
        );
        body.setAttribute('data-ds-highest-child-height', '');
        return;
      }
    }
  }

  const observer = new MutationObserver(handleMutations);

  // Since on initial load, it can happen that iframeHeight is 0, we need to use MutationObserver to watch for height change
  observer.observe(body, {
    attributes: true,
  });
}
